import { createBrowserHistory } from "history";

import iconHome from "src/Assets/iconography/sidebar_home.svg";
import iconCalendar from "src/Assets/iconography/sidebar_calendario.svg";
import iconMessages from "src/Assets/iconography/sidebar_mensajes.svg";
import iconResources from "src/Assets/iconography/sidebar_recursos.svg";
import iconProfile from "src/Assets/iconography/sidebar_mi_perfil.svg";
import iconNotes from "src/Assets/iconography/sidebar_notas.svg";
import iconGoals from "src/Assets/iconography/sidebar_metas.svg";
import iconActions from "src/Assets/iconography/sidebar_actions.svg";


export const menuClient = [
  {
    title: "Inicio",
    image: iconHome,
    link: "/dashboard",
  },
  {
    title: "Calendario",
    image: iconCalendar,
    link: "/calendar",
  },
  {
    title: "Metas",
    image: iconGoals,
    link: "/goals",
  },
  {
    title: "Acciones",
    image: iconActions,
    link: "/actions",
  },
  {
    title: "Recursos",
    image: iconResources,
    link: "/resources",
  },
  {
    title: "Mensajes",
    image: iconMessages,
    link: "/messages",
  },
  // {
  //   title: "Notas",
  //   image: iconNotes,
  //   link: "/notes",
  // }
];

export const history = createBrowserHistory();
